import React from "react";

export default function Filters({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  vendedorFilter,
  setVendedorFilter,
  vendedores,
  resetFilters,
}) {
  return (
    <div
      style={{
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
        gap: 20,
        flexWrap: "wrap",
        flexDirection: "row",
      }}
    >
      <input
        type="text"
        placeholder="🔎 Buscar por cliente o referencia..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          padding: 8,
          borderRadius: 8,
          border: "1px solid #ccc",
          width: 250,
        }}
      />

      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <span>
          <b>Estado:</b>
        </span>
        {["Todos", "Abierto", "Cerrado"].map((status) => (
          <button
            key={status}
            onClick={() => setStatusFilter(status)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              border:
                statusFilter === status
                  ? "2px solid #2D3748"
                  : "1px solid #ccc",
              backgroundColor: statusFilter === status ? "#E2E8F0" : "#fff",
              cursor: "pointer",
              fontWeight: statusFilter === status ? 600 : 400,
            }}
          >
            {status}
          </button>
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label>Desde:</label>
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          style={{ padding: 6, borderRadius: 6, border: "1px solid #ccc" }}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label>Hasta:</label>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          style={{ padding: 6, borderRadius: 6, border: "1px solid #ccc" }}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label>Vendedor:</label>
        <select
          value={vendedorFilter}
          onChange={(e) => setVendedorFilter(e.target.value)}
          style={{
            padding: 6,
            borderRadius: 6,
            border: "1px solid #ccc",
            width: 200,
          }}
        >
          <option value="">Todos</option>
          {(vendedores || []).map((v, i) => (
            <option key={i} value={v}>
              {v}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={resetFilters}
        style={{
          padding: "6px 12px",
          borderRadius: 6,
          backgroundColor: "#EDF2F7",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        Limpiar filtros
      </button>
    </div>
  );
}
